export default class Cache {
    /** Cache to store canvas instances and other stuff. */
    constructor() {
        this.cacheRepo = {};
    }

    put(namespace, key, value){
        if (!this.cacheRepo.hasOwnProperty(namespace)){
            this.cacheRepo[namespace] = {};
        }

        this.cacheRepo[namespace][key] = value;
    }

    get(namespace, key){
        if (!this.cacheRepo.hasOwnProperty(namespace)){
            return null;
        }
        if (!this.cacheRepo[namespace].hasOwnProperty(key)){
            return null;
        }
        return this.cacheRepo[namespace][key];
    }

    getAll(namespace){
        if (!this.cacheRepo.hasOwnProperty(namespace)){
            return {};
        }
        return this.cacheRepo[namespace];
    }

    remove(namespace, key){
        if (!this.cacheRepo.hasOwnProperty(namespace)){
            return null;
        }
        delete this.cacheRepo[namespace][key];
    }
}